import { DEFAULT_LIMIT } from '../../../constants';
const getItemsPerPageToUse = (itemsPerPage, limitToUse) => {
  if (limitToUse && itemsPerPage >= limitToUse) return limitToUse;
  return itemsPerPage || limitToUse || DEFAULT_LIMIT;
};
export default getItemsPerPageToUse;
//# sourceMappingURL=get-items-per-page-to-use.js.map